import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdditionRolesEditor, LazyChangePasswordForm, LazyContactInformationForm, LazyUpdateUserDataForm, LazyUpdateUserDataView, LazyUpdateUserdataForm, LazyBatchScanResult, LazyBoardStatusCell, LazyCellScanResult, LazyTokenCheck, LazyCollapsedBlock, LazyConfirmDialog, LazyAdditionMenu, LazyArrows, LazyBottomBar, LazyChevron, LazyDashItem, LazyDash, LazyLogoWhite, LazyLogo, LazyMobileMenu, LazyDrawer, LazyEditorForms, LazyEditorModal, LazyEditorTabs, LazyEditor, LazyComments, LazyHistory, LazyLead, LazyProducts, LazyTasks, LazyInWork, LazyBoard, LazyKanbanCardBtn, LazyKanbanCard, LazyMore, LazyKizScanResult, LazyLeftMenu, LazyMenuItem, LazyUserDropdown, LazyMainPageScanner, LazyModalAcceptance, LazyNotificationBell, LazyNotificationItem, LazyOrderScanResult, LazyGroupedMobile, LazyOrderItems, LazyOrderItemsMobile, LazyBadges, LazyCharacteristicsCategory, LazyCharacteristicsPackage, LazyCharacteristicsSpecs, LazyCharacteristics, LazyDesktopLayout, LazyEmptyState, LazyGallery, LazyHero, LazyIdentifiers, LazyProductScanResult, LazyKpiCards, LazyLoadingState, LazyMobileAccordion, LazyMobileLayout, LazyMobileStickyBar, LazyMobileStockList, LazyStockCard, LazyStockList, LazyProductCard, LazyInfo, LazyProductGallery, LazyProductInfo, LazyServices, LazySelectServices, LazyServiceCard, LazyScanResult, LazyShipmentAddSupplies, LazyShipmentCancelDialog, LazyShipmentCardHeader, LazyShipmentCard, LazyShipmentCreateWizard, LazyShipmentDashboardWidget, LazyShipmentDetails, LazyShipmentHistory, LazyShipmentKizReplace, LazyShipmentLinkCell, LazyShipmentList, LazyShipmentMoveDialog, LazyShipmentPlanner, LazyShipmentScan, LazyShipmentScopeSwitcher, LazyShipmentStatusBadge, LazyShipmentSupplies, LazyShipmentTimeInput, LazySidebar, LazyMobileHeader, LazyMobileMenuSlideover, LazyMobileNavBar, LazyUserProfile, LazyStatusStepper, LazyStickerScanResult, LazySupplyScanResult, LazyAddToShipment, LazyCreateSupply, LazyGuidedFlow, LazyStep, LazySelectionList, LazySupplyHeader, LazyFilterIcon, LazyLoader, LazyMobileCell, LazyAcceptanceCard, LazyBoardCard, LazyClientCard, LazyClientServiceCard, LazyLeadCard, LazyMobileProductCard, LazyOrderCard, LazyProductInCell, LazySupplyCard, LazyWarehouseCard, LazyWarehouseServiceCard, LazyWarehousemanUserCard, LazyDefaultCard, LazyCard, LazyCardActions, LazyCardAvatar, LazyCardCheckbox, LazyCardCollapsible, LazyCardComment, LazyCardFieldRow, LazyCardField, LazyCardInfoRow, LazyCardShell, LazyCardStatusBadge, LazyFilters, LazyHeader, LazyMobile, LazySimpleTable, LazyTableBarBtn, LazyTableBarMobile, LazyTableBar, LazyTableBtn, LazyTableCard, LazyTableComponent, LazyTableEmpty, LazyTableFilterRow, LazyTablePagination, LazyTableDetail, LazyTableFilter, LazyDesktopSection, LazyTable, LazyMobileSection, LazyModalsSection, LazyTaskScanResult, LazyTransitionContainer, LazyAttachmentTypeBadge, LazyFunctional, LazyButton, LazyDebugPanel, LazyCodeScanner, LazyScanProductCard, LazyScannerInput, LazyFileImport, LazyFileUploader, LazyAddressSearchField, LazyBarcode, LazyBarcodes, LazyCloseButton, LazyCustomerForm, LazyDatePicker, LazyDateRange, LazyEditButton, LazyMultiDatePicker, LazySimpleDatePicker, LazySubmitButton, LazyTimezoneSelect, LazyUserSelect, LazyInitColors, LazyInputMenu, LazyInputPassword, LazyInputPhone, LazyInputSelect, LazyInput, LazyKizDisclosureBadge, LazyKizPool, LazyKizReplace, LazyKizScan, LazyModal, LazyNameAvatar, LazyPasswordFields, LazyPhoneNumberInput, LazyBatch, LazyFefo, LazyModalHeader, LazyProcess, LazyProductModal, LazyInfoCell, LazyModalInfo, LazyKiz, LazyMove, LazyProgress, LazySource, LazyWarning, LazyReturnScan, LazyScanner, LazySelectMenu, LazyChevronIcon, LazySelectbox, LazyList, LazyTags, LazyServiceIntervals, LazySlideover, LazySuperFilterSelect, LazyCanvas, LazyTabs, LazyUnknownScanResult, LazyWarehouseStatus, LazySelectionActions, LazyServiceList, LazyKizModal, LazyPrinting, LazyProductsTable, LazyTaskProducts, LazyFormFields, LazyWarehousemanForm, LazyWarehousemanView, LazyEditorUser, LazyDynamicFormSection, LazyMainForm, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AdditionRolesEditor", LazyAdditionRolesEditor],
["ChangePasswordForm", LazyChangePasswordForm],
["ContactInformationForm", LazyContactInformationForm],
["UpdateUserDataForm", LazyUpdateUserDataForm],
["UpdateUserDataView", LazyUpdateUserDataView],
["UpdateUserdataForm", LazyUpdateUserdataForm],
["BatchScanResult", LazyBatchScanResult],
["BoardStatusCell", LazyBoardStatusCell],
["CellScanResult", LazyCellScanResult],
["TokenCheck", LazyTokenCheck],
["CollapsedBlock", LazyCollapsedBlock],
["ConfirmDialog", LazyConfirmDialog],
["AdditionMenu", LazyAdditionMenu],
["Arrows", LazyArrows],
["BottomBar", LazyBottomBar],
["Chevron", LazyChevron],
["DashItem", LazyDashItem],
["Dash", LazyDash],
["LogoWhite", LazyLogoWhite],
["Logo", LazyLogo],
["MobileMenu", LazyMobileMenu],
["Drawer", LazyDrawer],
["EditorForms", LazyEditorForms],
["EditorModal", LazyEditorModal],
["EditorTabs", LazyEditorTabs],
["Editor", LazyEditor],
["Comments", LazyComments],
["History", LazyHistory],
["Lead", LazyLead],
["Products", LazyProducts],
["Tasks", LazyTasks],
["InWork", LazyInWork],
["Board", LazyBoard],
["KanbanCardBtn", LazyKanbanCardBtn],
["KanbanCard", LazyKanbanCard],
["More", LazyMore],
["KizScanResult", LazyKizScanResult],
["LeftMenu", LazyLeftMenu],
["MenuItem", LazyMenuItem],
["UserDropdown", LazyUserDropdown],
["MainPageScanner", LazyMainPageScanner],
["ModalAcceptance", LazyModalAcceptance],
["NotificationBell", LazyNotificationBell],
["NotificationItem", LazyNotificationItem],
["OrderScanResult", LazyOrderScanResult],
["GroupedMobile", LazyGroupedMobile],
["OrderItems", LazyOrderItems],
["OrderItemsMobile", LazyOrderItemsMobile],
["Badges", LazyBadges],
["CharacteristicsCategory", LazyCharacteristicsCategory],
["CharacteristicsPackage", LazyCharacteristicsPackage],
["CharacteristicsSpecs", LazyCharacteristicsSpecs],
["Characteristics", LazyCharacteristics],
["DesktopLayout", LazyDesktopLayout],
["EmptyState", LazyEmptyState],
["Gallery", LazyGallery],
["Hero", LazyHero],
["Identifiers", LazyIdentifiers],
["ProductScanResult", LazyProductScanResult],
["KpiCards", LazyKpiCards],
["LoadingState", LazyLoadingState],
["MobileAccordion", LazyMobileAccordion],
["MobileLayout", LazyMobileLayout],
["MobileStickyBar", LazyMobileStickyBar],
["MobileStockList", LazyMobileStockList],
["StockCard", LazyStockCard],
["StockList", LazyStockList],
["ProductCard", LazyProductCard],
["Info", LazyInfo],
["ProductGallery", LazyProductGallery],
["ProductInfo", LazyProductInfo],
["Services", LazyServices],
["SelectServices", LazySelectServices],
["ServiceCard", LazyServiceCard],
["ScanResult", LazyScanResult],
["ShipmentAddSupplies", LazyShipmentAddSupplies],
["ShipmentCancelDialog", LazyShipmentCancelDialog],
["ShipmentCardHeader", LazyShipmentCardHeader],
["ShipmentCard", LazyShipmentCard],
["ShipmentCreateWizard", LazyShipmentCreateWizard],
["ShipmentDashboardWidget", LazyShipmentDashboardWidget],
["ShipmentDetails", LazyShipmentDetails],
["ShipmentHistory", LazyShipmentHistory],
["ShipmentKizReplace", LazyShipmentKizReplace],
["ShipmentLinkCell", LazyShipmentLinkCell],
["ShipmentList", LazyShipmentList],
["ShipmentMoveDialog", LazyShipmentMoveDialog],
["ShipmentPlanner", LazyShipmentPlanner],
["ShipmentScan", LazyShipmentScan],
["ShipmentScopeSwitcher", LazyShipmentScopeSwitcher],
["ShipmentStatusBadge", LazyShipmentStatusBadge],
["ShipmentSupplies", LazyShipmentSupplies],
["ShipmentTimeInput", LazyShipmentTimeInput],
["Sidebar", LazySidebar],
["MobileHeader", LazyMobileHeader],
["MobileMenuSlideover", LazyMobileMenuSlideover],
["MobileNavBar", LazyMobileNavBar],
["UserProfile", LazyUserProfile],
["StatusStepper", LazyStatusStepper],
["StickerScanResult", LazyStickerScanResult],
["SupplyScanResult", LazySupplyScanResult],
["AddToShipment", LazyAddToShipment],
["CreateSupply", LazyCreateSupply],
["GuidedFlow", LazyGuidedFlow],
["Step", LazyStep],
["SelectionList", LazySelectionList],
["SupplyHeader", LazySupplyHeader],
["FilterIcon", LazyFilterIcon],
["Loader", LazyLoader],
["MobileCell", LazyMobileCell],
["AcceptanceCard", LazyAcceptanceCard],
["BoardCard", LazyBoardCard],
["ClientCard", LazyClientCard],
["ClientServiceCard", LazyClientServiceCard],
["LeadCard", LazyLeadCard],
["MobileProductCard", LazyMobileProductCard],
["OrderCard", LazyOrderCard],
["ProductInCell", LazyProductInCell],
["SupplyCard", LazySupplyCard],
["WarehouseCard", LazyWarehouseCard],
["WarehouseServiceCard", LazyWarehouseServiceCard],
["WarehousemanUserCard", LazyWarehousemanUserCard],
["DefaultCard", LazyDefaultCard],
["Card", LazyCard],
["CardActions", LazyCardActions],
["CardAvatar", LazyCardAvatar],
["CardCheckbox", LazyCardCheckbox],
["CardCollapsible", LazyCardCollapsible],
["CardComment", LazyCardComment],
["CardFieldRow", LazyCardFieldRow],
["CardField", LazyCardField],
["CardInfoRow", LazyCardInfoRow],
["CardShell", LazyCardShell],
["CardStatusBadge", LazyCardStatusBadge],
["Filters", LazyFilters],
["Header", LazyHeader],
["Mobile", LazyMobile],
["SimpleTable", LazySimpleTable],
["TableBarBtn", LazyTableBarBtn],
["TableBarMobile", LazyTableBarMobile],
["TableBar", LazyTableBar],
["TableBtn", LazyTableBtn],
["TableCard", LazyTableCard],
["TableComponent", LazyTableComponent],
["TableEmpty", LazyTableEmpty],
["TableFilterRow", LazyTableFilterRow],
["TablePagination", LazyTablePagination],
["TableDetail", LazyTableDetail],
["TableFilter", LazyTableFilter],
["DesktopSection", LazyDesktopSection],
["Table", LazyTable],
["MobileSection", LazyMobileSection],
["ModalsSection", LazyModalsSection],
["TaskScanResult", LazyTaskScanResult],
["TransitionContainer", LazyTransitionContainer],
["AttachmentTypeBadge", LazyAttachmentTypeBadge],
["Functional", LazyFunctional],
["Button", LazyButton],
["DebugPanel", LazyDebugPanel],
["CodeScanner", LazyCodeScanner],
["ScanProductCard", LazyScanProductCard],
["ScannerInput", LazyScannerInput],
["FileImport", LazyFileImport],
["FileUploader", LazyFileUploader],
["AddressSearchField", LazyAddressSearchField],
["Barcode", LazyBarcode],
["Barcodes", LazyBarcodes],
["CloseButton", LazyCloseButton],
["CustomerForm", LazyCustomerForm],
["DatePicker", LazyDatePicker],
["DateRange", LazyDateRange],
["EditButton", LazyEditButton],
["MultiDatePicker", LazyMultiDatePicker],
["SimpleDatePicker", LazySimpleDatePicker],
["SubmitButton", LazySubmitButton],
["TimezoneSelect", LazyTimezoneSelect],
["UserSelect", LazyUserSelect],
["InitColors", LazyInitColors],
["InputMenu", LazyInputMenu],
["InputPassword", LazyInputPassword],
["InputPhone", LazyInputPhone],
["InputSelect", LazyInputSelect],
["Input", LazyInput],
["KizDisclosureBadge", LazyKizDisclosureBadge],
["KizPool", LazyKizPool],
["KizReplace", LazyKizReplace],
["KizScan", LazyKizScan],
["Modal", LazyModal],
["NameAvatar", LazyNameAvatar],
["PasswordFields", LazyPasswordFields],
["PhoneNumberInput", LazyPhoneNumberInput],
["Batch", LazyBatch],
["Fefo", LazyFefo],
["ModalHeader", LazyModalHeader],
["Process", LazyProcess],
["ProductModal", LazyProductModal],
["InfoCell", LazyInfoCell],
["ModalInfo", LazyModalInfo],
["Kiz", LazyKiz],
["Move", LazyMove],
["Progress", LazyProgress],
["Source", LazySource],
["Warning", LazyWarning],
["ReturnScan", LazyReturnScan],
["Scanner", LazyScanner],
["SelectMenu", LazySelectMenu],
["ChevronIcon", LazyChevronIcon],
["Selectbox", LazySelectbox],
["List", LazyList],
["Tags", LazyTags],
["ServiceIntervals", LazyServiceIntervals],
["Slideover", LazySlideover],
["SuperFilterSelect", LazySuperFilterSelect],
["Canvas", LazyCanvas],
["Tabs", LazyTabs],
["UnknownScanResult", LazyUnknownScanResult],
["WarehouseStatus", LazyWarehouseStatus],
["SelectionActions", LazySelectionActions],
["ServiceList", LazyServiceList],
["KizModal", LazyKizModal],
["Printing", LazyPrinting],
["ProductsTable", LazyProductsTable],
["TaskProducts", LazyTaskProducts],
["FormFields", LazyFormFields],
["WarehousemanForm", LazyWarehousemanForm],
["WarehousemanView", LazyWarehousemanView],
["EditorUser", LazyEditorUser],
["DynamicFormSection", LazyDynamicFormSection],
["MainForm", LazyMainForm],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
